$(function () {
    var body = $('body');
    var nav = $('.nav');
    var burger = $('.burger');
    var nav_trigger = $('.nav').find('ul li.menu-item-has-children > button, ul li.menu-item-has-children > a');
    var nav_align = 'right';
    var break_point = 992;
    var browser_width = window.innerWidth;
    var nav_width = 300;
    var nav_window = $('<div class="navwindow"></div>');
    body.append(nav_window);
    var nav_wrap = $('.navwrap');

    document.addEventListener('keydown', function (event) {
        const key = event.key;
        if (key === "Escape") {
            if (browser_width < break_point) {
                nav_reset();
                burger.focus();
            } else {
                $('.menu-item-has-children').removeClass('__active');
                body.removeClass('__blur');
            }
        }
    });

    nav_window.click(function (event) {
        nav_reset();
    });

    //burger click
    burger.click(function (event) {
        event.preventDefault();
        $(this).toggleClass('__active');
        if (body.hasClass('__mobile')) {
            nav_reset();
        } else {
            nav_launch();
        }
    });

    /*nav reset*/
    var nav_reset = function nav_reset() {
        burger.removeClass('__active');
        nav_window.hide();
        body.removeClass('__mobile');
        nav_wrap.removeClass('__active');
        nav_wrap.find('ul, div').removeClass('__active');
        body.removeClass('__blur');
    };

    /*nav launch*/
    var nav_launch = function nav_launch() {
        nav_window.show();
        body.addClass('__mobile');
        nav_wrap.addClass('__active');
    };

    
    function initMenu() {
        var browser_width = window.innerWidth;

        $( ".navwrap ul").on( "mouseenter focusin", function() {
            $('.navwrap ul').each(function () {
                var elem = $(this)
                var rect = elem[0].getBoundingClientRect();
                if(rect.x + rect.width > window.innerWidth) {
                    $(this).addClass('left');
                }
            });
        });

         // nav dropdown on focus/keyboard navigation
        if (browser_width >= break_point) {
            nav_trigger.click(function (event) {
                if($(this).is('button')) {
                    event.preventDefault();
                    $(this).parent().siblings().removeClass('__active');
                    $(this).parent().siblings().find('.__active').removeClass('__active');
                    $(this).parent().siblings().find('[aria-expanded="true"]').attr('aria-expanded', false);
                    $(this).parent().toggleClass('__active');
                    if($(this).parent().hasClass( '__active' )) {
                        $(this).attr('aria-expanded', true);
                    } else {
                        $(this).attr('aria-expanded', false);
                        $(this).parent().find('.__active').removeClass('__active');
                    }
                }
            });

            $(document).on("click", function (event) {
                if ($(event.target).closest(".nav[aria-label='Primary']").length === 0) {
                    nav.find('.__active').removeClass('__active');
                    nav.find('[aria-expanded="true"]').attr('aria-expanded', false);
                    body.removeClass('__blur');
                }
            });
        }

        if (browser_width < break_point) {
            nav_trigger.click(function (event) {
                event.stopPropagation();
                if ($(this).parent().children('ul').length > 0) {
                    $(this)
                        .parent().children('ul')
                        .addClass('__active');
                    $(this)
                        .parent().children('ul').find('li:first-child a, li:first-child button').focus();
                }
            });

            // Disable root item link click
            $('.menu-item-has-children > a').click(function (event) {
                event.preventDefault();
            });
        }

        if (browser_width < break_point) {

            nav.find('a, button').attr('tabindex', '-1');
            var back_menu = $('.backto');
            back_menu.click(function (event) {
                event.preventDefault();
                event.stopPropagation();
                $(this)
                    .parents('li')
                    .parent('ul')
                    .addClass('__active');
                $(this)
                    .parents('li').children('a').focus();
            });

        } else {
            nav_reset();
        }
        

        // Touch device check
        const isTouchDevice = () => {
            return window.matchMedia("(pointer: coarse)").matches
        }

        // Create view button for touchscreen devices
        var view_button = $('<li class="viewall"><a href="#">View</a></li>');
        
        // If desktop and touch device, disable link click and add extra view link
        if (browser_width > break_point && isTouchDevice()) {
            nav_trigger.click(function (event) {
                event.stopPropagation();
                if ($(this).children('ul').length > 0) {
                    event.preventDefault();
                }
            });

            nav_ul.prepend(view_button);
        }

        var view_all = $('.viewall');
        view_all.click(function (event) {
            event.stopPropagation();
        });

        var back_menu = $('.backto button');
        back_menu.click(function (event) {
            event.preventDefault();
            event.stopPropagation();
            $(this).closest('.__active').removeClass('__active');
        });
    }

    function InitMenuOnLoad() {
        if ($('.navwrap > .nav').length) {
            initMenu();
        } else {
            setTimeout(InitMenuOnLoad, 200);
        }
    }

    $(window).on('load', function () {
        InitMenuOnLoad();
    });

    $(window).on('resize', function(){
        initMenu();
    });
});